/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReserveAltArtIdResponse } from '../../models/reserve-alt-art-id-response';

export interface AdminServiceReserveAltArtId$Params {
  gachaId: string;
}

export function adminServiceReserveAltArtId(http: HttpClient, rootUrl: string, params: AdminServiceReserveAltArtId$Params, context?: HttpContext): Observable<StrictHttpResponse<ReserveAltArtIdResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceReserveAltArtId.PATH, 'get');
  if (params) {
    rb.path('gachaId', params.gachaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReserveAltArtIdResponse>;
    })
  );
}

adminServiceReserveAltArtId.PATH = '/api/v3/gateway/admin/stage/alt_art/reserve/gacha/{gachaId}';
